import styled from '@emotion/styled'
import { CSSProperties, useCallback, useMemo } from 'react'
import { useHistory } from 'react-router'
import Text from './Text'
import colors from '../../constant/colors'
import Image from './Image'
import { mobile } from '../../utils/responsive-helper'

type colorType = typeof colors[keyof typeof colors]

type HeadbarProps = {
  title: string
  backWard?: string
  isBackWard?: boolean
  style?: CSSProperties
  className?: string
  titleSize?: number
  titleColor?: colorType
}

export type ItemProps = {
  label: string
  path: string
}

const Layout = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-bottom: 42px;

  ${mobile} {
    padding: 0 40px;
  }
`
const IconBack = styled(Image)`
  width: 24px;
  height: 24px;
  cursor: pointer;
  position: absolute;
  left: 0;
`

const CustomLink: React.FC<{ path: string; color?: colorType }> = (
  props,
) => {
  const { path, color, ...rest } = props
  const history = useHistory()

  const icon = useMemo(() => {
    if (color === colors.WHITE) {
      return 'IconBackWhite'
    }

    return 'IconBack'
  }, [color])

  const onTextClick = useCallback(() => {
    history.push(path)
  }, [history, path])
  return (
    <IconBack imageName={icon} onClick={onTextClick} {...rest} />
  )
}

const CustomBack: React.FC<{ color?: colorType }> = (
  props,
) => {
  const { color, ...rest } = props
  const history = useHistory()

  const icon = useMemo(() => {
    if (color === colors.WHITE) {
      return 'IconBackWhite'
    }

    return 'IconBack'
  }, [color])

  const onTextClick = useCallback(() => {
    history.goBack()
  }, [history])
  return (
    <IconBack imageName={icon} onClick={onTextClick} {...rest} />
  )
}

const Headbar = (props: HeadbarProps) => {
  const { title, backWard, isBackWard = true, titleSize = 24, titleColor = colors.WHITE, ...rest } = props

  return (
    <Layout {...rest}>
      {isBackWard ?
        backWard ?
          <CustomLink path={backWard} color={titleColor} /> :
          <CustomBack color={titleColor} /> :
        <></>
      }
      <Text color={titleColor} size={titleSize} type='Bold'>
        {title}
      </Text>
    </Layout>
  )
}

export default Headbar
